import { APIRoutes } from '../../routes';
import apiInstance from '../index';

export async function getFeaturePermissions(): Promise<string[]> {
    const response = await apiInstance.get(APIRoutes.PERMISSIONS_FEATURES);

    if (!Array.isArray(response.data)) {
        throw new Error(
            `Permissions API returned unexpected format: expected array, got ${typeof response.data}`,
        );
    }

    return response.data;
}
